export default __webpack_public_path__ + "static/media/Views.3c99baf6.svg";